module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<select id="' +
((__t = (id)) == null ? '' : __t) +
'" class="DescartesUISelect form-control">\n    ';

        _.each(sizes,function(size) {
            var out = '<option value="';
            out += size.value + '" ';
            if(size.selected === true) {
                out += 'selected';
            }
            out += '>';
            out += size.label;
            out += '</option>';
            print(out);
        })
    ;
__p += '\n</select>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/Size.ejs
// module id = 415
// module chunks = 0